import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '@/src/store/rootReducer'
import { ITypeOfMeet, ISubType } from '@/src/types/typeOfMeet.type'

export interface IMeetTypeOfMeetState {
  types: ITypeOfMeet[]
  selectedTypeOfMeet: number | null
  submitted: boolean
}

export const typeOfMeetState: IMeetTypeOfMeetState = {
  types: [],
  selectedTypeOfMeet: null,
  submitted: false,
}

const typeOfMeetAdapter = createEntityAdapter()

export const typeOfMeetSlice = createSlice({
  name: 'typeOfMeet',
  initialState: typeOfMeetAdapter.getInitialState(typeOfMeetState),
  reducers: {
    setListTypesMeet: (state, action: PayloadAction<ITypeOfMeet[]>) => {
      state.types = action.payload
    },
    setSelectedTypeOfMeet: (state, action: PayloadAction<number>) => {
      state.selectedTypeOfMeet = action.payload
    },
    setSubmitted: (state, action: PayloadAction<boolean>) => {
      state.submitted = action.payload
    },
  },
})

export const { setListTypesMeet, setSelectedTypeOfMeet, setSubmitted } = typeOfMeetSlice.actions

export const { selectAll: typeOfMeetSelector } = typeOfMeetAdapter.getSelectors(
  (state: RootState) => state[typeOfMeetSlice.name],
)

export const selectTypesOfMeet = (state: RootState) => state.typeOfMeet.types
export const selectTypeOfMeet = (state: RootState) => state.typeOfMeet.selectedTypeOfMeet
export const selectSubmitted = (state: RootState) => state.typeOfMeet.submitted
